import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container container">
        <div className="footer-row">
          <div className="footer-column">
            <h3 className="footer-logo">
              <span className="logo-prefer">Prefer</span>
              <span className="logo-build">Build</span>
            </h3>
            <p className="footer-about">
              We are dedicated to building dreams and constructing futures. With over 40 years of excellence in the ferrocement construction industry, we bring your vision to life with quality and precision.
            </p>
            <div className="social-links">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
            </div>
          </div>
          
          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Our Services</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/projects">Projects</Link></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h4>Our Services</h4>
            <ul className="footer-links">
              <li><Link to="/services/residential">Residential Construction</Link></li>
              <li><Link to="/services/commercial">Commercial Building</Link></li>
              <li><Link to="/services/renovation">Renovation & Remodeling</Link></li>
              <li><Link to="/services/architecture">Architecture & Design</Link></li>
              <li><Link to="/services/consulting">Construction Consulting</Link></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h4>Contact Info</h4>
            <ul className="contact-info">
              <li>
                <FaMapMarkerAlt />
                <span>Ghaziabad, Uttar Pradesh</span>
              </li>
              <li>
                <FaPhoneAlt />
                <span>(+91)9911966848</span>
              </li>
              <li>
                <FaEnvelope />
                <span>preferindustries@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="container">
          <div className="copyright">
            <p>&copy; {new Date().getFullYear()} PreferBuild Construction Company. All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
